var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isReady)?_c('v-fade-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1):_c('app-init')
}
var staticRenderFns = []

export { render, staticRenderFns }